// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button[data-v-56606f63] {
  background-color: #484848;
  width: 44px;
  height: 40px;
  display: flex;
  justify-content: center;
  place-items: center;
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;
  overflow: hidden;
}
.icon-button[data-v-56606f63] {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-button-with-submenu[data-v-56606f63] {
  height: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.button.expanded[data-v-56606f63] {
  width: 183px;
  justify-content: flex-start;
  padding: 0 12px;
}
.button.expanded .icon-button[data-v-56606f63] {
  width: auto;
  text-transform: capitalize;
}
.button.expanded .icon-button-with-submenu[data-v-56606f63] {
  width: 100%;
  text-transform: capitalize;
}
.menu-arrow[data-v-56606f63] {
  transform: rotateX(180deg);
  filter: invert(79%) sepia(9%) saturate(11%) hue-rotate(314deg) brightness(91%) contrast(92%);
}
.menu-text[data-v-56606f63] {
  text-wrap: wrap;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  width: 122px;
  line-height: 1;
  letter-spacing: 0.5px;
  color: #b5b5b5;
  padding-left: 8px;
}
.menu-text.active[data-v-56606f63] {
  color: #484848;
}
a[data-v-56606f63],
a[data-v-56606f63]:hover,
a[data-v-56606f63]:visited,
a[data-v-56606f63]:active {
  color: inherit;
  text-decoration: none;
}
a:hover .button[data-v-56606f63] {
  background-color: #595959;
}
a .button.active[data-v-56606f63] {
  background-color: #F4F4F4;
  color: black;
}

/* This applies the dark filter */
.button.active img[data-v-56606f63] {
  filter: brightness(0.6);
}

/* This applies the BLUE filter, but requires .menu-icon class */
.button.selected img.menu-icon[data-v-56606f63] {
  filter: invert(0.5) sepia(1) saturate(5) hue-rotate(175deg);
}
img.menu-arrow[data-v-56606f63] {
  transition: 0.25s transform ease-in-out;
}
.circle-container[data-v-56606f63] {
  width: 20px;
  display: flex;
  align-items: center;
  justify-items: center;
}
.slide-up-enter-active[data-v-56606f63] {
  transition: max-height 0.2s ease-in;
}
.slide-up-leave-active[data-v-56606f63] {
  transition: max-height 0.2s ease-out;
}
.slide-up-enter-to[data-v-56606f63],
.slide-up-leave-from[data-v-56606f63] {
  overflow: hidden;
  max-height: var(--submenu-height);
}
.slide-up-enter-from[data-v-56606f63],
.slide-up-leave-to[data-v-56606f63] {
  overflow: hidden;
  max-height: 0;
}
.submenu-container a:not(:last-child) .button[data-v-56606f63] {
  margin-bottom: 0.25rem;
}
.sidebar-button-container[data-v-56606f63] {
  max-width: max-content;
}
.sidebar-button-container .button-link[data-v-56606f63] {
  background-color: rgb(237, 237, 237);
  box-shadow: 0 0 10px 0 rgba(33, 33, 33, 0.15);
  display: block;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
